var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 22 22",
    fill: "nont",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 2.86671C12.5466 2.86671 13.7999 4.12004 13.7999 5.66671C13.7999 7.21337 12.5466 8.46671 10.9999 8.46671C9.45325 8.46671 8.19992 7.21337 8.19992 5.66671C8.19992 4.12004 9.45325 2.86671 10.9999 2.86671ZM10.9999 14.8667C14.9599 14.8667 19.1333 16.8134 19.1333 17.6667V19.1334H2.86659V17.6667C2.86659 16.8134 7.03992 14.8667 10.9999 14.8667ZM10.9999 0.333374C8.05325 0.333374 5.66658 2.72004 5.66658 5.66671C5.66658 8.61337 8.05325 11 10.9999 11C13.9466 11 16.3333 8.61337 16.3333 5.66671C16.3333 2.72004 13.9466 0.333374 10.9999 0.333374ZM10.9999 12.3334C7.43992 12.3334 0.333252 14.12 0.333252 17.6667V21.6667H21.6666V17.6667C21.6666 14.12 14.5599 12.3334 10.9999 12.3334Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.3b806092.svg";
export { ForwardRef as ReactComponent };